import { COLOR_PRIMARY } from "../../constants/colors";

const IconEqual = ({ color = {COLOR_PRIMARY} }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  <path fill={color} d="M4 7h16v2H4V7Zm0 8h16v2H4v-2Z"></path>
</svg>
  )

export default IconEqual;